import React from 'react';
import {Redirect, Route, RouteProps} from 'react-router-dom';
import {useAppSelector} from 'store/store.config';
import {RoutesPaths} from 'navigation/routes';

const BaseRoute: React.FC<RouteProps> = (props) => {
    const isAuth = useAppSelector(state => state.authReducer.isAuth)

    return  !isAuth ?
        (<Route path={props.path} exact={props.exact} component={props.component}/>)
        :
        (<Redirect to={RoutesPaths.TAB.toString()}/>);
};
export  default  BaseRoute;
